import React from 'react';
import HeaderComponent from '../HeaderComponent'
import MainServiceComponent from './MainServiceComponent';
import FooterComponent from '../FooterComponent';

export default function ServiciosComponent() {
  return (
    <>
      <HeaderComponent />
      <br />
      <MainServiceComponent />
      <br />
      <FooterComponent />
    </>
  )
}
